/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDatasetsCategoriesDetailPanelStyles = makeStyles(theme => ({
  detailPanelRoot: {
    padding: '15px 20px',
  },
  blockInfo: {
    color: theme.palette.text.primary,
    marginBottom: '10px',

    '&:last-child': {
      marginBottom: '0',
    },

    '& span': {
      margin: '0 25px 0 5px',
    },
  },
}));
